import React, { useState, useEffect } from "react";
import Modal from "../Modal/Modal";
import { Toggle } from "../Toggle/Toggle";
import { Button } from "../Button";
import { useTheme } from "../../contexts/Theme/ThemeContext";
import Swal from "sweetalert2";
import {
  CampoCsvPedido,
  LayoutCsvPedido,
  carregarLayoutCsvPedido,
  defaultLayoutCsvPedido,
  labelsCamposCsvPedido,
  labelsCamposCsvProdutos,
  localStorageKeyCsvPedidos,
} from "../../types/LayoutCsv";
import { ModalLayoutImpressaoContainer } from "../ModalLayoutImpressao/styles";

interface ModalLayoutCsvProps {
  isOpen: boolean;
  onClose: () => void;
}

const ModalLayoutCsv: React.FC<ModalLayoutCsvProps> = ({ isOpen, onClose }) => {
  const { theme } = useTheme();

  const [config, setConfig] = useState<LayoutCsvPedido>(carregarLayoutCsvPedido());

  useEffect(() => {
    if (isOpen) {
      setConfig(carregarLayoutCsvPedido());
    }
  }, [isOpen]);

  const handleToggleField = (field: CampoCsvPedido, value: boolean) => {
    setConfig((prev) => ({
      ...prev,
      [field]: value,
    }));
  };

  const handleSave = () => {
    if (!Object.values(config).some((value) => value === true)) {
      Swal.fire({
        icon: "warning",
        title: "Atenção",
        text: "Selecione pelo menos um campo.",
      });
      return;
    }

    localStorage.setItem(localStorageKeyCsvPedidos, JSON.stringify(config));
    onClose();
  };

  const handleCancel = () => {
    setConfig(carregarLayoutCsvPedido());
    onClose();
  };

  const handleReset = () => {
    setConfig({ ...defaultLayoutCsvPedido });
  };

  const secoes = [
    { titulo: "Informações do pedido", labels: labelsCamposCsvPedido },
    { titulo: "Produtos", labels: labelsCamposCsvProdutos },
  ];

  return (
    <Modal
      isOpen={isOpen}
      setModal={onClose}
      width="lg"
      maxWidth="600px"
      align="center"
      justify="center"
      padding="24px"
    >
      <ModalLayoutImpressaoContainer theme={theme}>
        <div className="header">
          <h2 className="fonteTitulo">Configurar campos do CSV</h2>
          <p className="fonteTexto subtitulo">
            Selecione quais campos deseja exportar no arquivo. Com algum campo
            de produto marcado, o arquivo terá uma linha por item do pedido.
          </p>
        </div>

        <div className="content scrollBonito">
          {secoes.map((secao) => (
            <div className="secao" key={secao.titulo}>
              <h3 className="fonteSubtitulo secao-titulo">{secao.titulo}</h3>
              <div className="campos-grid">
                {(Object.keys(secao.labels) as CampoCsvPedido[]).map((campo) => (
                  <label key={campo} className="campo fonteTexto">
                    <Toggle
                      value={config[campo]}
                      onChange={(value) => handleToggleField(campo, value)}
                    />
                    <span>{secao.labels[campo]}</span>
                  </label>
                ))}
              </div>
            </div>
          ))}
        </div>

        <div className="footer">
          <Button
            title="Restaurar padrão"
            className="botao-reset"
            onClick={handleReset}
          />
          <div className="botoes-principais">
            <Button
              title="Cancelar"
              className="botao-cancelar"
              onClick={handleCancel}
            />
            <Button
              title="Salvar"
              className="botao-salvar"
              onClick={handleSave}
            />
          </div>
        </div>
      </ModalLayoutImpressaoContainer>
    </Modal>
  );
};

export default ModalLayoutCsv;
